// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e4a9ac8f","453":"ef0eceeb","455":"0dd246c9","644":"bcd4a68b"}[chunkId] + ".chunk.js";
};